import { GAType } from "./ga.types.namespace";

export class GAContants {
    static EventType: { [key in EventType]: GAType.EventType } = {
        'SEND': 'send',
    };
    static HitType: { [key in HitType]: GAType.HitType } = {
        'EVENT': 'event',
        'PAGEVIEW': 'pageview',
    };
    static EventCategory: { [key in EventCategory]: GAType.EventCategory } = {
        'ANCHOR': 'anchor',
        'BUTTON': 'button',
        'MESSAGE': 'message',
        'SELECT-DIALOG': 'select-dialog',
        'NETWORK': 'network',
        'AUTO': 'auto',
    };

    // TODO Convert these to enums
    static EventAction: { [key in EventAction]: GAType.EventAction } = {
        'PAGE-CHANGE': 'page-change',
        'FILE-UPLOAD-START': 'file-upload-start',
        'FILE-UPLOAD-END': 'file-upload-end',
        'FILE-UPLOAD-FAILED': 'file-upload-failed',
        'FILE-UPLOAD-READY': 'file-upload-ready',
        'FILE-UPLOAD-CLICKED': 'file-upload-clicked',
        'FILE-DOWNLOAD': 'file-download',
        'MODEL-OPEN': 'model-open',
        'FILE-DOWNLOAD-ZIP': 'file-download-zip',
        'FILE-SELECT-DIALOG-OPENED': 'file-select-dialog-opened',
        'FILE-SELECTED': 'file-selected',
        'FILE-CONVERT-START': 'file-convert-start',
        'FILE-CONVERT-END': 'file-convert-end',
        'FILE-CONVERT-FAILED': 'file-convert-failed',
        'OFFLINE-ENGINE-DOWNLOADED': 'offline-engine-downloaded',
        'FILE-PROCESSOR-RESOLVE-START': 'file-processor-resolve-start',
        'FILE-PROCESSOR-RESOLVE-END': 'file-processor-resolve-end',
        'FILE-PROCESSOR-RESOLVE-FAILED': 'file-processor-resolve-failed',
        'SHARE-CLICK': 'share-click',
    };
    static EventLabel: { [key in EventLabel]: GAType.EventLabel } = {
        'NAVIGATE': 'navigate',
        'DOWNLOAD': 'download',
        'UPLOAD': 'upload',
        'SELECT': 'select',
        'CONVERT': 'convert',
        'ERROR': 'error',
        'COMPLETE': 'complete',
        'PACKAGE_DOWNLOAD': 'package_download',
    };
    static EventValue = {};
}

export type EventType = 'SEND';
export type HitType = 'EVENT' | 'PAGEVIEW';
export type EventCategory = 'ANCHOR'
    | 'BUTTON'
    | 'MESSAGE'
    | 'SELECT-DIALOG' | 'NETWORK' | 'AUTO';
export type EventAction = 'PAGE-CHANGE'

    | 'FILE-UPLOAD-START'
    | 'FILE-UPLOAD-END'
    | 'FILE-UPLOAD-FAILED'
    | 'FILE-UPLOAD-READY'
    | 'FILE-UPLOAD-CLICKED'

    | 'FILE-SELECT-DIALOG-OPENED'
    | 'FILE-SELECTED'

    | 'FILE-CONVERT-START'
    | 'FILE-CONVERT-END'
    | 'FILE-CONVERT-FAILED'

    | 'FILE-DOWNLOAD'
    | 'MODEL-OPEN'
    | 'FILE-DOWNLOAD-ZIP'

    | 'FILE-PROCESSOR-RESOLVE-START'
    | 'FILE-PROCESSOR-RESOLVE-END'
    | 'FILE-PROCESSOR-RESOLVE-FAILED'
    | 'SHARE-CLICK'

    | 'OFFLINE-ENGINE-DOWNLOADED';

export type EventLabel = 'NAVIGATE'
    | 'DOWNLOAD'
    | 'UPLOAD'
    | 'SELECT'
    | 'CONVERT'
    | 'ERROR'
    | 'COMPLETE'
    | 'PACKAGE_DOWNLOAD';
export type EventValue = any;
